
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {sendcommandmessage, setdevicenotify, setdevicenotifytype} from '../../api/device'
export default {
name: 'childDevice7006',
directives: {
TransferDom
},
data () {
return {
showAdd: false,
addText: '成功',
addWarn: false,
warnText: '失败',
deviceData: '',
openShow: false,
openTitle: '',
openIndex: '',
isList: true,

alarmPhone: {
phone1: '',
phone2: '',
phone3: ''
},

phoneBookList: [],
isEdit: false,
isDel: false,
editIndex: '',
hintPhoneBook: '',
phoneBookObj: {
name: '',
phone: '',
icon: 'http://baidu.com',
im: ''
},

fmList: [],
hintFm: '',
fmObj: {
name: '',
frequency: ''
},

showDisabled: false,
openAlarm: false,

resultWay: []
}
},
created () {

this.deviceData = this.$store.getters.get_child_obj
if (this.deviceData.notify === 1) {
this.openAlarm = true
} else {
this.openAlarm = false
}

this.getStartData()
},
mounted () {},
methods: {

getStartData () {
if (this.deviceData.phonedevicerole === 'admin') {
this.showDisabled = false
} else {
this.showDisabled = true
}
this.resultWay = []
let notifytype = this.deviceData.notifytype.split('')
if (notifytype[0] === '1') {
this.resultWay.push('1')
}
if (notifytype[1] === '1') {
this.resultWay.push('2')
}
if (notifytype[2] === '1') {
this.resultWay.push('3')
}
this.phoneBookList = []
this.fmList = []
this.deviceData = this.$store.getters.get_child_obj
let arr = this.deviceData.setting !== null && this.deviceData.setting !== '' && this.deviceData.setting.length > 0 ? this.deviceData.setting : []
console.log('arr', arr)
for (let i = 0; i < arr.length; i++) {
let startObj = ''
if (arr[i].other && arr[i].other !== '') {
startObj = JSON.parse(arr[i].other)
}
if (arr[i].func === 'setalarmcallphone') {
this.alarmPhone.phone1 = startObj.command1
} else if (arr[i].func === 'phonebook') {

let obj = {}
if (startObj.command1 !== '') {
let dataArr = startObj.command1.split('|')
obj = {name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]}
this.phoneBookList.push(obj)
}
if (startObj.command2 !== '') {
let dataArr = startObj.command2.split('|')
obj = {name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]}
this.phoneBookList.push(obj)
}
if (startObj.command3 !== '') {
let dataArr = startObj.command3.split('|')
obj = {name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]}
this.phoneBookList.push(obj)
}
if (startObj.command4 !== '') {
let dataArr = startObj.command4.split('|')
obj = {name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]}
this.phoneBookList.push(obj)
}
if (startObj.command5 !== '') {
let dataArr = startObj.command5.split('|')
obj = {name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]}
this.phoneBookList.push(obj)
}
if (startObj.reserved1 !== '') {
let dataArr = startObj.reserved1.split('|')
obj = {name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]}
this.phoneBookList.push(obj)
}
if (startObj.reserved2 !== '') {
let dataArr = startObj.reserved2.split('|')
obj = {name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]}
this.phoneBookList.push(obj)
}
} else if (arr[i].func === 'setfm') {

let obj = {}
if (startObj.command1 !== '') {
let dataArr = startObj.command1.split('#')
obj = {name: dataArr[0], frequency: dataArr[1]}
this.fmList.push(obj)
}
if (startObj.command2 !== '') {
let dataArr = startObj.command2.split('#')
obj = {name: dataArr[0], frequency: dataArr[1]}
this.fmList.push(obj)
}
if (startObj.command3 !== '') {
let dataArr = startObj.command3.split('#')
obj = {name: dataArr[0], frequency: dataArr[1]}
this.fmList.push(obj)
}
if (startObj.command4 !== '') {
let dataArr = startObj.command4.split('#')
obj = {name: dataArr[0], frequency: dataArr[1]}
this.fmList.push(obj)
}
if (startObj.command5 !== '') {
let dataArr = startObj.command5.split('#')
obj = {name: dataArr[0], frequency: dataArr[1]}
this.fmList.push(obj)
}
if (startObj.reserved1 !== '') {
let dataArr = startObj.reserved1.split('#')
obj = {name: dataArr[0], frequency: dataArr[1]}
this.fmList.push(obj)
}
if (startObj.reserved2 !== '') {
let dataArr = startObj.reserved2.split('#')
obj = {name: dataArr[0], frequency: dataArr[1]}
this.fmList.push(obj)
}
}
}
},
changeOpen () {
this.changeNBDefence()
},

changeNBDefence () {
let data = {did: this.deviceData.id, notify: 0}
if (this.openAlarm) {
data.notify = 1 
} else {
data.notify = 0 
}
setdevicenotify(data).then(res => {
if (res.code === 200) {
this.showAdd = true
this.addText = '成功'
this.deviceData.notify = data.notify
} else {
this.addWarn = true
this.warnText = '失败'
this.openAlarm = !this.openAlarm
}
this.$store.commit('set_child_obj', this.deviceData)
}).catch(() => {
this.addWarn = true
this.warnText = '布防失败'
if (data.notify === 0) {
this.deviceData.notify = 1
} else {
this.deviceData.notify = 0
}
})
},
openWindowShow (index) {
if (index === 1) {
this.openTitle = '报警号码'
} else if (index === 2) {
this.openTitle = '通讯录'
} else if (index === 3) {
this.openTitle = 'FM频率'
} else {
this.openTitle = ''
}
this.isList = true
this.openIndex = index
this.openShow = true
},

changeWaySend () {

let way = '000'
let notifytype = this.deviceData.notifytype
for (let i = 0; i < this.resultWay.length; i++) {
if (this.resultWay[i] === '1') {
way = '1' + way.slice(1)
} else if (this.resultWay[i] === '2') {
way = way.slice(0, 1) + '1' + way.slice(2)
} else if (this.resultWay[i] === '3') {
way = way.slice(0, 2) + '1'
}
}
notifytype = way + notifytype.slice(3)
let data = {
phone: this.$store.getters.get_user,
did: this.deviceData.id,
notifytype
}
setdevicenotifytype(data).then(res => {
if (res.code === 200) {
this.deviceData.notifytype = data.notifytype
this.$toast.success('成功')

this.$store.commit('set_child_obj', this.deviceData)
} else {
this.$toast.fail('失败')
let wayArr = []
let notifytype = this.deviceData.notifytype.split('')
if (notifytype[0] === '1') {
wayArr.push('1')
}
if (notifytype[1] === '1') {
wayArr.push('2')
}
if (notifytype[2] === '1') {
wayArr.push('3')
}
this.resultWay = wayArr
}
}).catch(() => {
let wayArr = []
let notifytype = this.deviceData.notifytype.split('')
if (notifytype[0] === '1') {
wayArr.push('1')
}
if (notifytype[1] === '1') {
wayArr.push('2')
}
if (notifytype[2] === '1') {
wayArr.push('3')
}
this.resultWay = wayArr
this.$toast.fail('失败')
})

},
addSet (isAdd, item, index) {
if (isAdd) {
this.phoneBookObj = {name: '', phone: '', icon: 'http://baidu.com', im: ''}
this.fmObj = {name: '', frequency: ''}
} else {
this.isEdit = true
this.editIndex = index

this.phoneBookObj = {name: item.name, phone: item.phone, icon: item.icon, im: item.im}
}
if (this.openIndex === 2) {
if (isAdd) {
this.openTitle = '添加电话'
} else {
this.openTitle = '编辑电话'
}
} else if (this.openIndex === 3) {
this.openTitle = '添加FM频率'
} else {
this.openTitle = ''
}
this.isList = false
},
backPage () {
if (this.openIndex === 2) {
this.openTitle = '通讯录'
} else if (this.openIndex === 3) {
this.openTitle = 'FM频率'
} else {
this.openTitle = ''
}
this.isList = true
},
delPhoneBook (index) {
let arr = this.clone(this.phoneBookList)
arr.splice(index, 1)

this.isDel = true
this.sendSetDevice(arr)
},
addEditSetPhoneBook () {
if (this.phoneBookObj.name === '') {
this.hintPhoneBook = '请输入姓名。'
return
} else if (this.phoneBookObj.phone === '') {
this.hintPhoneBook = '请输入号码。'
return
}
this.hintPhoneBook = ''
let arr = this.phoneBookList
let obj = this.phoneBookObj
if (!this.isEdit) {
if (this.phoneBookObj.im === '') {
obj.im = '112'
}
arr.push(obj)
} else {
arr[this.editIndex] = obj
}
this.sendSetDevice(arr)
},
DelFm (index) {
let arr = this.clone(this.fmList)
arr.splice(index, 1)
this.isDel = true
this.sendSetDevice(arr)
},
addSetFm () {
if (this.fmObj.name === '') {
this.hintFm = '请输入电台名称。'
return
} else if (this.fmObj.frequency === '') {
this.hintFm = '请输入电台频率。'
return
}
this.hintFm = ''
let arr = this.fmList
let obj = this.fmObj
arr.push(obj)
this.sendSetDevice(arr)
},
sendSetDevice (arr) {
let data = {
imei: this.deviceData.deviceid,
did: this.deviceData.id,
method: '',
command1: '',
command2: '',
command3: '',
command4: '',
command5: '',
reserved1: '',
reserved2: ''
}
if (this.openIndex === 1) {
data.method = 'setalarmcallphone'
data.command1 = this.alarmPhone.phone1
} else if (this.openIndex === 2) {
data.method = 'phonebook'

for (let i = 0; i < arr.length; i++) {
let phonebook = arr[i].name + '|' + arr[i].phone + '|' + arr[i].icon + '|' + arr[i].im
if (i === 0) {
data.command1 = phonebook
} else if (i === 1) {
data.command2 = phonebook
} else if (i === 1) {
data.command3 = phonebook
} else if (i === 1) {
data.command4 = phonebook
} else if (i === 1) {
data.command5 = phonebook
} else if (i === 1) {
data.reserved1 = phonebook
} else if (i === 1) {
data.reserved2 = phonebook
}
}

} else if (this.openIndex === 3) {
data.method = 'setfm'

for (let i = 0; i < arr.length; i++) {
let fm = arr[i].name + '#' + arr[i].frequency
if (i === 0) {
data.command1 = fm
} else if (i === 1) {
data.command2 = fm
} else if (i === 1) {
data.command3 = fm
} else if (i === 1) {
data.command4 = fm
} else if (i === 1) {
data.command5 = fm
} else if (i === 1) {
data.reserved1 = fm
} else if (i === 1) {
data.reserved2 = fm
}
}
}
sendcommandmessage(data).then(res => {
if (res.code === 200) {

let isNo = true
for (let i = 0; i < this.deviceData.setting.length; i++) {
if (this.deviceData.setting[i].func === data.method) {
this.deviceData.setting[i].other = JSON.stringify(data)
isNo = false
}
}
if (isNo) {
let obj = {confirmon: '', func: data.method, other: JSON.stringify(data), seton: '', status: 0, value: 700}
this.deviceData.setting.push(obj)
}
this.$store.commit('set_child_obj', this.deviceData)
this.showAdd = true
this.addText = '成功'
if (this.isList) {
if (this.isDel) {
this.isDel = false
} else {
this.openShow = false
}
} else {
this.isList = !this.isList
}
this.getStartData()
} else {
this.addWarn = true
this.warnText = '失败'
}
}).catch(() => {
this.addWarn = true
this.warnText = '失败'
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/childDevice7006.vue